import { createContext, FunctionComponent, useContext, useEffect, useState } from "react";
import TenantService, { Tenant } from "../services/TenantService/TenantService";

const TenantContext = createContext<Tenant | undefined>(undefined);

export const TenantProvider: FunctionComponent = ({ children }) => {
    const [tenant, setTenant] = useState<Tenant>();

    useEffect(() => {
        (async function fetchTenant() {
            const fetchedTenant = await TenantService.getTenant();
            setTenant(fetchedTenant);
        })();
    }, []);

    return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
};

export const useTenant = () => {
    return useContext(TenantContext);
};

export const useCurrency = () => {
    const tenant = useContext(TenantContext);
    return tenant?.currency;
};
